import { render } from "./EditBoardModal.vue?vue&type=template&id=0d47296e&scoped=true"
import script from "./EditBoardModal.vue?vue&type=script&lang=js"
export * from "./EditBoardModal.vue?vue&type=script&lang=js"

import "./EditBoardModal.vue?vue&type=style&index=0&id=0d47296e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d47296e"

export default script